import cx from 'classnames';
import styles from './JackpotIcon.module.scss';

import { Typography } from '@shared/Typography';
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@app/store';
import { useCloseOnOutsideClick } from '@utils/hooks';
import { setHideTooltip } from '@pages/JackpotPage/store/jackpotSlice';
import { getLeague } from '@utils/getLeague';

export const JackpotIconTooltip = () => {
  const dispatch = useAppDispatch();
  const timerRef = useRef<number | null>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const { tooltipParams } = useAppSelector((state) => state.jackpot);

  useCloseOnOutsideClick([tooltipRef], () => dispatch(setHideTooltip()));

  useEffect(() => {
    if (!tooltipParams) return;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(() => {
      dispatch(setHideTooltip());
      timerRef.current = null;
    }, 2000);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [dispatch, tooltipParams]);

  if (!tooltipParams) return null;

  return (
    <div
      ref={tooltipRef}
      className={cx(
        styles.jackpotIconTooltip,
        tooltipParams.jackpotSlug && styles[tooltipParams.jackpotSlug],
      )}
      style={
        tooltipParams.leftDirection
          ? {
              position: 'fixed',
              top: tooltipParams.position.top - 24,
              left: tooltipParams.position.left - 52,
            }
          : {
              position: 'fixed',
              top: tooltipParams.position.top - 24,
              left: tooltipParams.position.left + 10,
            }
      }
    >
      <Typography
        component="description2"
        textTransform="uppercase"
        className={cx(
          styles.tooltipText,
          tooltipParams.jackpotSlug && styles[tooltipParams.jackpotSlug],
        )}
      >
        {tooltipParams.jackpotSlug ? getLeague(tooltipParams.jackpotSlug) : '-'}
      </Typography>

      <Typography
        component="description2"
        className={cx(
          styles.tooltipAmount,
          tooltipParams.jackpotSlug && styles[tooltipParams.jackpotSlug],
        )}
      >
        {`$${tooltipParams.drawAmount}`}
      </Typography>
    </div>
  );
};
